import { type AxiosResponse } from 'axios'

export function exportFileFormat (response: AxiosResponse<any, any>, labelName: string): void {
  const url = window.URL.createObjectURL(
    new Blob([response.data], { type: 'application/x-pem-file' })
  )
  const link = document.createElement('a')
  link.href = url
  link.setAttribute(
    'download', formatDownloadName(labelName))
  document.body.appendChild(link)
  link.click()
  link.parentNode?.removeChild(link)
}

export function formatDownloadName (filePrefix: string): string {
  return `${filePrefix}.pem`
}
